export enum OrderMarketTypeEnum {
    Stock,
    Option,
    Future,
    Fractionary = 10,
    ETFFractionary = 13
}